/**
 * Escape a CSV cell and wrap in quotes when needed.
 */
const escapeCell = (value) => {
  const str = value == null ? "" : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

/**
 * Download rows as a UTF-8 CSV file (with BOM for Excel Arabic support).
 * @param {string[]} headers
 * @param {Array<Array<string|number>>} rows
 * @param {string} filename
 */
export const downloadCsv = (headers, rows, filename) => {
  const lines = [
    headers.map(escapeCell).join(","),
    ...rows.map((row) => row.map(escapeCell).join(",")),
  ];
  const bom = "\uFEFF";
  const blob = new Blob([bom + lines.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportTopDesignsCsv = (designs = []) => {
  const headers = ["Rank", "Id", "Name", "Code", "Quantity", "Revenue", "OrderCount"];
  const rows = designs.map((d, i) => [
    i + 1,
    d.id,
    d.name,
    d.code || "",
    d.quantity,
    d.revenue,
    d.orderCount,
  ]);
  downloadCsv(headers, rows, `grabatko-top-designs-${Date.now()}.csv`);
};

export const exportOrdersSummaryCsv = (kpis, dateRange) => {
  const headers = ["Metric", "Value", "StartDate", "EndDate"];
  const rows = [
    ["TotalOrders", kpis?.totalOrders ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["TotalPieces", kpis?.totalPieces ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["TotalRevenue", kpis?.totalRevenue ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["TotalProfit", kpis?.totalProfit ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["AverageOrderValue", kpis?.averageOrderValue ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["ConfirmationRate", kpis?.confirmationRate ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["CouponUsageRate", kpis?.couponImpact?.couponUsageRate ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
    ["TotalDiscountGiven", kpis?.couponImpact?.totalDiscountGiven ?? 0, dateRange?.startDateUtc, dateRange?.endDateUtc],
  ];
  downloadCsv(headers, rows, `grabatko-orders-summary-${Date.now()}.csv`);
};

export const exportCouponPerformanceCsv = (coupons = []) => {
  const headers = ["Code", "Redemptions", "TotalDiscount", "TotalRevenue", "AverageOrderValue"];
  const rows = coupons.map((c) => [
    c.code,
    c.redemptions,
    c.totalDiscount,
    c.totalRevenue,
    c.averageOrderValue,
  ]);
  downloadCsv(headers, rows, `grabatko-coupon-performance-${Date.now()}.csv`);
};
